import { render, staticRenderFns } from "./BestSellerLayout.vue?vue&type=template&id=60a6d68b"
import script from "./BestSellerLayout.vue?vue&type=script&lang=js"
export * from "./BestSellerLayout.vue?vue&type=script&lang=js"
import style0 from "./BestSellerLayout.vue?vue&type=style&index=0&id=60a6d68b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports